import { ValidatorRuleBase } from 'src/app/utilities/validation/validator-rule-base';
import { ModelValidator } from './model-validator';

export class ModelValidatorRule<
  TModel,
  TInput,
  TMetadata,
> extends ValidatorRuleBase<TMetadata> {
  private isValidPredicate: (inputValue: TInput) => boolean;
  private shouldValidatePredicate: (model: TModel) => boolean;

  constructor(
    private owner: ModelValidator<TModel, TMetadata>,
    key: string,
    private inputPredicate: (model: TModel) => TInput,
    metadata: any,
  ) {
    super(key, metadata);
  }

  protected override doValidate(): boolean {
    if (!this.isValidPredicate) return true;

    let shouldValidate = true;
    if (this.shouldValidatePredicate) {
      shouldValidate = this.shouldValidatePredicate(this.owner.model);
    }
    if (!shouldValidate) return true;

    let inputValue = this.inputPredicate(this.owner.model);
    let isValid = this.isValidPredicate(inputValue);

    return isValid;
  }

  must(
    predicate: (inputValue: TInput) => boolean,
  ): ModelValidatorRule<TModel, TInput, TMetadata> {
    if (this.isValidPredicate) {
      throw 'Validation predicate cannot change after being set.';
    }
    this.isValidPredicate = predicate;
    return this;
  }

  when(
    predicate: (model: TModel) => boolean,
  ): ModelValidatorRule<TModel, TInput, TMetadata> {
    if (this.shouldValidatePredicate) {
      throw 'Validation predicate cannot change after being set.';
    }
    this.shouldValidatePredicate = predicate;
    return this;
  }
}
